export const STATUS_ACTION = {
    CREATE_STATUS: 'Create status',
    UPDATE_STATUS: 'Update status',
    UPDATE_STATUS_WO_CHANGED_DATA: 'Update status without data change'    
  }
  